export default {"src":"/_next/static/media/cart.fe10664e.svg","height":24,"width":24};